import { EmailValidator } from 'commons-validator-js';
import { Collection, Map } from 'immutable';

import { Place } from '../records/Place';

export const REQUIRED_ERROR_MESSAGE = 'Required';

const MIN_HOURLY_WAGE = 1;
const MAX_HOURLY_WAGE = 300;

export function validateRequired(state, ...fields) {
  let errors = Map();

  fields.forEach((fieldName) => {
    const fieldValue = state[fieldName];
    if (
      fieldValue === null ||
      typeof fieldValue === 'undefined' ||
      Number.isNaN(fieldValue) ||
      fieldValue.length === 0
    ) {
      errors = errors.set(fieldName, REQUIRED_ERROR_MESSAGE);
    } else if (fieldValue instanceof Place && !fieldValue.city) {
      errors = errors.set(fieldName, REQUIRED_ERROR_MESSAGE);
    } else if (fieldValue instanceof Collection && fieldValue.isEmpty()) {
      errors = errors.set(fieldName, REQUIRED_ERROR_MESSAGE);
    }
  });

  return errors;
}

export function validateEmail(email) {
  let error = '';

  const validator = new EmailValidator();

  if (!validator.isValid(email)) {
    error = "This isn't a valid email address.";
  }

  return error;
}

export function validateNumRange(input, min, max) {
  const num = Number(input);
  if (Number.isNaN(num) || num < min || num > max) {
    return `Must be between ${min} and ${max}`;
  }
  return '';
}

export function validateHourlyWage(wage) {
  if (wage == null || wage === '') return '';
  const num = wage.toString().trim().replace('$', '');
  return validateNumRange(num, MIN_HOURLY_WAGE, MAX_HOURLY_WAGE);
}

export function validateNumUpTo(max, input) {
  if (input == null || input === '') return '';
  const num = parseInt(input.toString().trim(), 10);
  if (Number.isNaN(num) || num < 0 || num > max) {
    return `Must be between 0 and ${max}`;
  }
  return '';
}

export function validateURL(str) {
  const a = document.createElement('a');
  a.href = str;
  if (!a.host || a.host === window.location.host) {
    return 'Must be a valid url';
  }
  return '';
}
